import MaskDirectLogin from '../src/MaskDirectLogin';
export default MaskDirectLogin;
